import { UserRole } from '@kainos/shared';
import type { SessionUser } from '@/lib/auth/session';

export const DEMO_TENANT_ID = 'org_acme';

/**
 * Session used while `VITE_USE_MOCKS` is on, so the shell renders with a real
 * user in place instead of bouncing to the sign-in screen.
 */
export const DEMO_USER: SessionUser = {
  id: 'usr_renata',
  fullName: 'Renata Vidal',
  email: 'renata.vidal@example.com',
  jobTitle: 'PMO Lead',
  role: UserRole.ADMIN,
  tenantId: DEMO_TENANT_ID,
  organizationName: 'Constructora Andes',
};
